
export default {
  props:['selectedContactId', 'selectedContactName']
};
